import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'intl-pluralrules';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath, CMSPath, current_client_config, currentIP, DOOR_KEY_TYPES, getAppConfig, GLOBAL_IV, GLOBAL_SALT, LAUNCHED, MOBILE_CHECKIN_CATEGORY } from './config/Constant';
import { getServerDateTime } from './Redux/Actions/serverDateTimeAction';
import { getCurrentLayout, getPrefLangSchedule } from './js/layoutSelector';
import { getHotelLang } from './Redux/Actions/hotelLangAction';
import { setCurrentLayout, setCurrentWidget } from './Redux/Reducers/deviceConfigReducer';
import { mapFloatingWidgetsToNavItem, mapWidgetsToNavItem, navItemsConstant } from './js/getNavItems';
import { getHotelList } from './Redux/Actions/hotelSelectorAction';
import { CustomPreLoader } from './Apps/startLoader/preLoader';
import { makeLayoutApiCalls, triggerRepitativeApiCalls } from './js/fetchAppConfigs';
import { NavigationContainer, useNavigation } from '@react-navigation/native';
import { setClientId, setConnectorIP, setDoorKeyType, setFCMToken, setGoHome, setInitAppLogout, setIsAutoLoggedIn, setIsOnline, setShowOfflineMessage, setOpenChat, setProceedHotelSelection, setRenderApp, setRenderIpChangeModal, setServiceStatus, setShowLoginModal } from './Redux/Reducers/appConfigReducer';
import { setHcommerceStoreSkuData } from './Redux/Reducers/hcommerceReducer';
import { AesUtil } from './js/AesUtil';
import { setBookingStatus, setPreCheckInStatus } from './Redux/Reducers/checkInReducer';
import { handleOpenChat, initializeChat } from './Apps/chat/initializeChat';
import { InnspireChatBot } from './Apps/chat/innspireChatBot';
import FadeTransition from './components/fadeTransition';
import { AppState, Platform, SafeAreaView, StatusBar, Text, View } from 'react-native';
import {AppLifecycle} from 'react-native-applifecycle';
import { HomeNavigator } from './navigation/StackNavigator/stackNavigator';
import GuestRoomStatus from './Apps/guestRoomStatus/index.js';
import FetchingDataScreen from './components/fetchingDataScreen/index.js';
import FlashMessageComp from './components/flashMessage/flashMessage';
import { initializeDoorKey } from './Apps/doorKey/initializeDoorkey.js';
import { linkToRoom } from './Redux/Actions/roomLinkingAction.js';
import { setProceedLoginToTheApp, setRenderFlashMessage, setRenderInfoPopup, setRenderLoader } from './Redux/Actions/appConfigAction.js';
import SystemNavigationBar from 'react-native-system-navigation-bar';
import { useCssStyle } from './customHook/getCssStyle.js';
import { clearSelectedItems } from './Redux/Reducers/guestRequestReducer.js';
import { guestJourneyNotification } from './Redux/Actions/gjNotificationAction.js';
import { sendAnalytics } from './Redux/Actions/analyticsAction.js';
import { wipeGuestData } from './js/wipeGuestData.js';
import { setGuestRoomData, setGuestRoomState } from './Redux/Reducers/guestRoomReducer.js';
import AutoLoginSuccessModal from './Apps/guestRoomStatus/AutoLoginSuccessModal.js';
import { handleDeepLinkAction } from './js/deeplink.js';
import InfoPopupModal from './components/infoPopupModal/index.js';
import { HOME_PAGE } from './navigation/StackNavigator/routes.js';
import { getGuestItineraryList } from './Redux/Actions/guestItineraryAction.js';
import { updateDynamicStyle } from './Redux/Reducers/dynamicStyleSheetReducer.js';
import { setLocationSelectErrorPopup } from './Redux/Reducers/hotelSelectorReducer.js';
import { handleLocationSelect } from './js/hotelSelector.js';
import { useTranslation } from 'react-i18next';
import useWidgetClickHandler from './customHook/useWidgetClickHandler.js';
import KeyboardAvoidingWrapper from './components/keyboardAvoidingWrapper/index.js';
import { checkAppHealthService } from './Redux/Actions/appHealthService.js';
import { CustomTextInput } from './components/customTextInput/index.js';
import CustomPressable from './components/customPressable/customPressable.js';
import { getCleanUrl } from './utils/Helper.js';
import { requestNotificationPermission } from './js/requestPermissions/notifications/requestNotificationPermission';
import { checkBookingStatus } from './Redux/Actions/checkInAction.js';
import { checkPreCheckInWidgetState } from './js/preCheckInWidgetState.js';
import OfflineModal from './components/offlineModal/index.js';
import NetInfo from "@react-native-community/netinfo";

let crashlytics;
if (Platform.OS !== 'web') {
  const moduleName = '@react-native-firebase/crashlytics';
  import(/* webpackIgnore: true */ moduleName)
    .then(module => {
      crashlytics = module.default;
    })
    .catch(() => {});
}

export const RootApp = React.memo(() => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigation = useNavigation();
    const getStyles = useCssStyle();

    const appState = useRef(AppState.currentState);

    let aesUtil = new AesUtil(128, 1000);


    const checkedBookingState = useRef(false);
    const innspireChatRef = useRef(null);

    const { appSessionToken, DeviceIdentifier, isAutoLoggedIn, fcmToken, goHome, canProceedRenderApp, renderApp, proceedHotelSelection, proceedLoginToTheApp, initAppLogout, renderLoader, renderFlashMessage, renderInfoPopup, isLoggedIn, showLoginModal, overlayVisible, layoutCssData, isOnline, showOfflineMessage, openChat, renderIpChangeModal } = useSelector(state => state.appConfigSlice)
    const renderAppTimeout = useRef(null);
    const renderAppRef = useRef(renderApp);

    const { currentGuestDetails, gotGuestDetailsResponse } = useSelector(state => state.guestDetailsSlice);
    const { webAppWidgetsInfo, currentLayout } = useSelector(state => state.deviceConfigSlice)
    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice)
    const { hotelLanguages } = useSelector(state => state.hotelLangSlice)
    const { chatInterface } = useSelector(state => state.appPreservedConfigSlice);
    const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);
    const { hotelListData, locationSelectionErrorPopup } = useSelector(state => state.hotelSelectorSlice);
    const { redirectInfo } = useSelector(state => state.deeplinkSlice);

    const [modalCurrentIP, setModalCurrentIp] = useState(currentIP);
    const [modalClientId, setModalClientId] = useState(current_client_config)


    const handleOnWidgetClick = useWidgetClickHandler();




    useEffect(() => {
        if(initAppLogout){
            handleBookingDataState();
            handlePreCheckInDataState();
            dispatch(setInitAppLogout(false));
            dispatch(wipeGuestData({innspireChatRef}));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[initAppLogout])



    /* Initialize Login */

    const handleConnectCallback = (status, errorMessage) => {
        dispatch(setRenderLoader(false));
    }

    useEffect(() => {
        if (proceedLoginToTheApp.init) {
            dispatch(setRenderLoader(true, "Connecting to your room..."));
            dispatch(linkToRoom(proceedLoginToTheApp.guestDetails, handleConnectCallback));
            dispatch(setProceedLoginToTheApp(false, {}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [proceedLoginToTheApp])



    /* Hotel Selector */
    const handleContinueHotelSelection = () => {
        dispatch(handleLocationSelect(locationSelectionErrorPopup.selectedHotel, (result) => {
              if (result.status == "ALREADY_AT_SELECTED_HOTEL") {
                console.log("Same hotel selected, no changes made.");
              }

            },true));

        handleCloseHotelSelectorPopup();
    }


    const handleCloseHotelSelectorPopup = () => {
        dispatch(setRenderInfoPopup(false));
        dispatch(dispatch(setLocationSelectErrorPopup({isVisible: false})))
    }

    useEffect(() => {
        if(locationSelectionErrorPopup.isVisible){
            dispatch(setRenderInfoPopup(true, 
                {
                    title: t('hotelListWidget.confirmation'),
                    subtitle:t('hotelListWidget.confirmation_subtitle'),
                    onClose: handleCloseHotelSelectorPopup,
                    secondaryBtnLabel:"No",
                    onContinue: handleContinueHotelSelection,
                    primaryBtnLabel:"Yes"
                })
            )
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[locationSelectionErrorPopup.isVisible])


    useEffect(() => {
        if(hotelListData && proceedHotelSelection.init){
            const required_hotel_code = proceedHotelSelection.hotel_Code;
            const hotelListsInfo = hotelListData?.payload?.data;
            
            dispatch(setProceedHotelSelection(false));
            
            for (const hotelDataWithRegion of hotelListsInfo) {
                if (hotelDataWithRegion.hotelList && hotelDataWithRegion.hotelList?.length > 0) {
                    for (const hotelData of hotelDataWithRegion.hotelList) {
                        if (hotelData.hotelPropertyKey == required_hotel_code) {
                            dispatch(setRenderLoader(true, "Redirecting..."));
                            dispatch(handleLocationSelect(hotelData,
                                (result) => {
                                    dispatch(setRenderLoader(false));

                                    if (result.status = "ALREADY_AT_SELECTED_HOTEL") {
                                        console.log("Same hotel selected, no changes made.");
                                    }
                                }
                            ));
                            break;
                        }
                    }
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[hotelListData, proceedHotelSelection])



    /* Go Home */
    const handleGoHome = () => {

        dispatch(setGoHome(false));
        dispatch(setCurrentWidget({}));
        dispatch(clearSelectedItems());
        dispatch(guestJourneyNotification());

        const navigationState = navigation.getState();
        const stackScreens = navigationState.routes;
        console.log("current navigation stack: ", stackScreens);
        
        // keep this can go back to preserve homepage state
        if (navigation.canGoBack()) {
            navigation.goBack();
        } else {
            const currentRoute = stackScreens[stackScreens.length - 1]?.name;
            if (currentRoute === HOME_PAGE) {
                console.log("Already on HOME_PAGE, no navigation needed.");
                return;
            }
            
            navigation.reset({
                index: 0,
                routes: [{ name: HOME_PAGE }],
            });
        }
    }

    useEffect(() => {

        if (goHome) {
            handleGoHome();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [goHome])



    /*Initialize Chat */
    useEffect(() => {
        if (isOnline && chatInterface.interfaceKey) dispatch(initializeChat());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOnline, chatInterface.interfaceKey])






    const updateAndInitializeDoorkeyInterface = () => {
        const digitalKeyInterface = webAppWidgetsInfo.appConfigs?.digitalKeyInterface;

        if (digitalKeyInterface) {
            // Find the matching door key type
            const doorKeyType = Object.keys(DOOR_KEY_TYPES).find((key) =>
                DOOR_KEY_TYPES[key].includes(digitalKeyInterface)
            );

            if (doorKeyType) {
                dispatch(setDoorKeyType(doorKeyType));
                dispatch(initializeDoorKey(doorKeyType));
                return;
            }
        }
    };

    useEffect(() => {

        if (Object.keys(webAppWidgetsInfo).length > 0) {
            updateAndInitializeDoorkeyInterface()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webAppWidgetsInfo, fcmToken, isLoggedIn])





    const handleBookingDataState = async () => {
        const bookingDataAsPerHotel = await AsyncStorage.getItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST");

        const allBookingData = bookingDataAsPerHotel && JSON.parse(bookingDataAsPerHotel);
        const bookingData = allBookingData?.[current_client_config];

        try {
            if (bookingData) {
                const bookingDataParse = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", bookingData));

                if(isLoggedIn || initAppLogout){
                    delete allBookingData[current_client_config];
                    await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                    dispatch(setBookingStatus({
                        isBookingFound: false,
                        bookingData: {}
                    }))
                    return;
                }

                const serverDateObj = new Date(serverTimeDataObj?.date?.slice(0, 10));
                const checkinDateObj = new Date(bookingDataParse.checkinDate);
                const plannedCheckOutDateObj = bookingDataParse.plannedCheckOutDate ? new Date(bookingDataParse.plannedCheckOutDate.split('T')[0]) : null;
    
                if(plannedCheckOutDateObj){
                    if(plannedCheckOutDateObj < serverDateObj){
                        delete allBookingData[current_client_config];
                        await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                } else {
                    if(serverDateObj > checkinDateObj) {
                        delete allBookingData[current_client_config];
                        await AsyncStorage.setItem("X_BOOKING_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allBookingData));
                        dispatch(setInitAppLogout(true));
                        return;
                    }
                }

                AsyncStorage.setItem("connectorIP", currentIP);
                AsyncStorage.setItem("clientId", current_client_config);
                dispatch(setBookingStatus({
                    isBookingFound: true,
                    bookingData: bookingDataParse
                }))
            } else {
                checkedBookingState.current = true;
            }
        } catch (error) {
            console.log("error parsing booking data");
        }
    }


    const handlePreCheckInDataState = async () => {
        const preCheckInDataAsPerHotel = await AsyncStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST");

        const allPreCheckInData = preCheckInDataAsPerHotel && JSON.parse(preCheckInDataAsPerHotel);
        const preCheckInData = allPreCheckInData?.[current_client_config];

        try {
            if (preCheckInData) {

                if(isLoggedIn || initAppLogout){
                    delete allPreCheckInData[current_client_config];
                    await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allPreCheckInData));
                    dispatch(setPreCheckInStatus({
                        preCheckInCompleted: false,
                        preCheckInData: {},
                    }));
                    return;
                }

                const preCheckInDataParse = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", preCheckInData));

                const serverDateObj = new Date(serverTimeDataObj?.date?.slice(0, 10));
                const checkinDateObj = new Date(preCheckInDataParse.checkinDate);
    
                if (serverDateObj > checkinDateObj) {
                    delete allPreCheckInData[current_client_config];
                    await AsyncStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(allPreCheckInData));
                    dispatch(setInitAppLogout(true));
                    return;
                }

                AsyncStorage.setItem("connectorIP", currentIP);
                AsyncStorage.setItem("clientId", current_client_config);
                dispatch(setPreCheckInStatus({
                    preCheckInCompleted: true,
                    preCheckInData: preCheckInDataParse
                }))
            }
        } catch (error) {
            console.log("error parsing pre check-in data")
        }
    };
    

    useEffect(() => {

        if(isBookingFound && !checkedBookingState.current){
            checkedBookingState.current = true;
            dispatch(checkBookingStatus(bookingData, "", LAUNCHED));
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[isBookingFound])


    useEffect(() => {
        if(Object.keys(serverTimeDataObj).length > 0 && current_client_config){
            handleBookingDataState();
            handlePreCheckInDataState();
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[serverTimeDataObj])





    const updateFCMTokenForRegisterDevice = async (token) => {

        if(!appSessionToken){
            console.log("No app session Token Found")
            return;
        }

        if(!token || token == ""){
            console.log("No FCM Token Found")
            return;
        }

        console.log("updating fcm token:", token);

        const body = {
            "header" : {
            "sessionToken" : appSessionToken,
            "deviceType" : Platform.OS
            },
            "payload": {
                "deviceTokenIdentifier" : token
            }
        }
    
        try {
            let data = await clientConfigPath.put(`/guestDevice/update`, body)
    
            console.log("success updating FCM Token")
        } catch (error) {
            console.log("error updating FCM Token", error)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            if(fcmToken && appSessionToken) updateFCMTokenForRegisterDevice(fcmToken);
        }, 3000);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[fcmToken, appSessionToken])



    useEffect(() => {
        if(chatInterface?.interfaceKey && openChat){
            dispatch(setOpenChat(false));
            dispatch(handleOpenChat());
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[chatInterface?.interfaceKey, openChat])



    const mapCurrentLayout = async () => {

        let props = {
            dispatch,
            setHcommerceStoreSkuData,
            hotelLanguage: hotelLanguages,
            webAppWidgetsInfo,
            serverTimeDataObj
        }

        let currentSchedule = await getPrefLangSchedule(props);
        let currentLayout = await getCurrentLayout(props, currentSchedule);

        let getMappedWidgetsWithNavItem = mapWidgetsToNavItem(props, currentLayout.scrollableWidgets, navItemsConstant);
        let floatingWidgetsWithNavItem = mapFloatingWidgetsToNavItem(currentLayout.floatingWidgets, navItemsConstant)
        let mapCurrentLayoutWithNavItems = {
            ...currentLayout,
            scrollableWidgets: getMappedWidgetsWithNavItem,
            floatingWidgets: floatingWidgetsWithNavItem
        };
        dispatch(setCurrentLayout(mapCurrentLayoutWithNavItems));
        console.log("currentLayoutID------", currentLayout.durationId)

        setTimeout(() => {
            dispatch(setRenderApp(true));
        }, 10);
    }

    // get current schedule and layout
    useEffect(() => {

        // wait till makelayoutapicalls is completed
        if (canProceedRenderApp && Object.keys(webAppWidgetsInfo).length > 0 && Object.keys(serverTimeDataObj).length > 0 && Object.keys(hotelLanguages).length > 0 && (isLoggedIn || gotGuestDetailsResponse)) {
            mapCurrentLayout();
            dispatch(checkPreCheckInWidgetState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canProceedRenderApp, webAppWidgetsInfo, serverTimeDataObj, hotelLanguages, isLoggedIn, gotGuestDetailsResponse])


    useEffect(()=>{
        async function fetchLayoutCSS (){
            const currentDurationId = currentLayout?.durationId
            if (currentDurationId && layoutCssData?.length) {
                for (const cssData of layoutCssData) {
                    if (cssData.layoutId == currentDurationId) {
                        try {
                            const response = await fetch(getCleanUrl(cssData.customCSSFile));
                            const cssJson_data = await response.json();
    
                            console.log("CSS data:", cssJson_data);
                            dispatch(updateDynamicStyle(cssJson_data));
                        } catch (error) {
                            console.log("Error fetching CSS file:", error);
                        }  
                    }
                }
            }
        }

        fetchLayoutCSS();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLayout, layoutCssData])



    useEffect(() => {

        if(renderApp && !initAppLogout && redirectInfo && Object.keys(redirectInfo)?.length > 0){
            setTimeout(() => {
                dispatch(handleDeepLinkAction(redirectInfo, navigation));
            }, 500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[renderApp, redirectInfo])


    useEffect(() => {
        renderAppRef.current = renderApp;

        if (renderApp) {
            if (renderAppTimeout.current) {
                clearTimeout(renderAppTimeout.current);
                renderAppTimeout.current = null; // Reset the reference
            }

            dispatch(sendAnalytics("APP_LAUNCH", LAUNCHED, {}));
        } else {
            renderAppTimeout.current = setTimeout(() => {
                dispatch(setServiceStatus({ hasError: true, errorMessage: "Unable to reach server. Please try again." }))
                dispatch(sendAnalytics("APP_LAUNCH", "SERVER_TIMEDOUT", {}));
            }, 40000);
        }

        return () => {
            if (renderAppTimeout.current) {
                clearTimeout(renderAppTimeout.current);
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderApp]);




    useEffect(() => {
        if(isLoggedIn || isBookingFound){
            dispatch(checkAppHealthService());
            dispatch(getGuestItineraryList());
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[isLoggedIn, isBookingFound])



    const handleAppStateChange = async (nextAppState) => {
        console.log("App State Changed: ", nextAppState);
        
        if (appState.current.match(/inactive|background/) && nextAppState === 'active') {

            if(!fcmToken){
                console.log('App came to foreground — rechecking notification permission');
                dispatch(requestNotificationPermission());
            }

        }

        appState.current = nextAppState;
    }


    useEffect(() => {

        const appStateListner = AppLifecycle.addEventListener('change',handleAppStateChange);

        let lastConnectivityStatus = null;
        const connectivityListner = NetInfo.addEventListener((state) => {
            const online = state.isConnected && state.isInternetReachable;
            console.log("Internet connectivity changed:", online);

            if ( typeof online === 'boolean' && online !== lastConnectivityStatus) {
                dispatch(setIsOnline(online));
                lastConnectivityStatus = online;

                if(online){
                    if(!renderAppRef.current){
                        dispatch(makeLayoutApiCalls({isOnline: lastConnectivityStatus}));
                    } else {
                        dispatch(triggerRepitativeApiCalls());
                    }
                } else {
                    if(!renderAppRef.current){
                        dispatch(makeLayoutApiCalls({isOnline: lastConnectivityStatus}));
                    }
                }
            }
        });

        return () => {
            connectivityListner();
            appStateListner.remove();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClientConfigChange = () => {
        dispatch(setConnectorIP(modalCurrentIP));
        dispatch(setClientId(modalClientId));
        
        dispatch(setInitAppLogout(true));
    }

    return (
        <View style={getStyles(['rootContainer'])}>
            <StatusBar translucent backgroundColor={"transparent"} />
            <KeyboardAvoidingWrapper keyboardVerticalOffset={0}>
            {renderApp ?
                <>
                    <FadeTransition duration={300}>
                        <HomeNavigator />
                    </FadeTransition>

                    {showLoginModal && <GuestRoomStatus />}

                    {renderLoader.isVisible && <FetchingDataScreen loaderMessage={renderLoader.loaderMessage} />}
                    {renderFlashMessage.isVisible && <FlashMessageComp messageConfig={renderFlashMessage.messageConfig} />}
                    
                    {renderInfoPopup.isVisible && 
                        <InfoPopupModal 
                            type={renderInfoPopup.popupConfig.type}
                            title={renderInfoPopup.popupConfig.title}
                            subtitle={renderInfoPopup.popupConfig.subtitle}
                            onClose={() => renderInfoPopup.popupConfig?.onClose?.() || dispatch(setRenderInfoPopup(false))}
                            secondaryBtnLabel={renderInfoPopup.popupConfig.secondaryBtnLabel}
                            onContinue={renderInfoPopup.popupConfig?.onContinue ? () => renderInfoPopup.popupConfig?.onContinue?.() : null}
                            primaryBtnLabel={renderInfoPopup.popupConfig.primaryBtnLabel}
                        />
                    }

                    {renderIpChangeModal && 
                        <InfoPopupModal>
                            <View style={getStyles(["changeConfigModalContainer"])} id='changeConfigModalContainer'>
                                <View style={getStyles(["changeConfigModalHeaderContainer"])} id='changeConfigModalHeaderContainer'>
                                    <Text style={getStyles(["changeConfigModalHeaderTitle"])} id="changeConfigModalHeaderTitle"></Text>
                                </View>

                                <View style={getStyles(["changeConfigModalMainContainer"])} id='changeConfigModalMainContainer'>
                                    <View style={getStyles(['textContainer', 'changeConfigTextContainer'])} id='textContainer changeConfigTextContainer'>
                                        <Text style={getStyles(['label', 'changeConfigLabel'])} id='label changeConfigLabel'>{t('changeConfigModal.current_ip')}<Text style={getStyles(['requiredText'])}>*</Text></Text>
                                        <CustomTextInput
                                            value={modalCurrentIP}
                                            onChangeText={setModalCurrentIp}
                                            placeholder={t('changeConfigModal.current_ip_placeholder')}
                                        />
                                    </View>

                                    <View style={getStyles(['textContainer', 'changeConfigTextContainer'])} id='textContainer changeConfigTextContainer'>
                                        <Text style={getStyles(['label', 'changeConfigLabel'])} id='label changeConfigLabel'>{t('changeConfigModal.client_id')}<Text style={getStyles(['requiredText'])}>*</Text></Text>
                                        <CustomTextInput
                                            value={modalClientId}
                                            onChangeText={setModalClientId}
                                            placeholder={t('changeConfigModal.client_id_placeholder')}
                                        />
                                    </View>

                                    <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleClientConfigChange}>
                                        <Text style={getStyles(['primaryBtnTxt'])}>{"Submit"}</Text>
                                    </CustomPressable>

                                    <CustomPressable style={getStyles(['secondaryBtn'])} onPress={()=> dispatch(setRenderIpChangeModal(false))}>
                                        <Text style={getStyles(['secondaryBtnTxt'])}>{"Close"}</Text>
                                    </CustomPressable>
                                </View>

                            </View>
                        </InfoPopupModal>
                    }


                    {isOnline && chatInterface?.interfaceKey?.toLowerCase() == "innspirechat" &&
                        <InnspireChatBot ref={innspireChatRef} />
                    }
                    {overlayVisible && <View style={getStyles(['customOverlayContainer'])}></View>}

                    {(isAutoLoggedIn && isLoggedIn) && <AutoLoginSuccessModal />}

                    {showOfflineMessage && <OfflineModal />}
                </>
                :
                <CustomPreLoader />
            }
            </KeyboardAvoidingWrapper>
        </View>
    )
});